(function () {

        function pad2(n) { return (n < 10 ? "0" : "") + n; }

        function getNextMidnight() {
            var now = new Date();
            var midnight = new Date();
            midnight.setHours(24, 0, 0, 0);
            return midnight.getTime();
        }

        var elH = document.getElementById("sz-hh");
        var elM = document.getElementById("sz-mm");
        var elS = document.getElementById("sz-ss");

        function tick() {
            var now = new Date().getTime();
            var end = getNextMidnight();
            var diff = end - now;

            var totalSec = Math.floor(diff / 1000);
            var hrs = Math.floor(totalSec / 3600);
            var mins = Math.floor((totalSec % 3600) / 60);
            var secs = totalSec % 60;

            elH.textContent = pad2(hrs);
            elM.textContent = pad2(mins);
            elS.textContent = pad2(secs);
        }

        tick();
        setInterval(tick, 1000);

    })();